import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ForgotPassword } from 'src/app/shared/interfaces/forgot-password.interface';
import { PasswordService } from 'src/app/shared/services/password.service';
import { TurnstileService } from 'src/app/shared/services/turnstile.service';
import { TurnstileComponent } from 'src/app/shared/components/turnstile/turnstile.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  @ViewChild('turnstileWidget') turnstileWidget!: TurnstileComponent;

  forgotPasswordForm!: FormGroup;
  successMessage!: string;
  showSuccess: boolean = false;
  errorMessage: string = '';
  showError: boolean = false;
  isLoading = false;
  isFormReady = false;
  turnstileToken: string | null = null;
  siteKey = environment.turnstileSiteKey;

  constructor(
    private formBuilder: FormBuilder,
    private passwordService: PasswordService,
    private turnstileService: TurnstileService,
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.isFormReady = !this.forgotPasswordForm.invalid;

    this.forgotPasswordForm.statusChanges.subscribe(e => this.isFormReady = 'INVALID' != e)
  }

  onTurnstileToken(token: string | null): void {
    this.turnstileToken = token;
    this.turnstileService.setToken(token);
  }

  forgotPassword() {
    this.showSuccess = false;
    this.showError = false;
    this.errorMessage = '';

    if (this.forgotPasswordForm.valid && this.turnstileToken) {
      const forgotPassword: ForgotPassword = {
        email: this.forgotPasswordForm.get('email')?.value,
      };

      this.isLoading = true;
      this.passwordService.forgotPassword(forgotPassword).subscribe({
        next: () => {
          this.showSuccess = true;
          this.successMessage = 'The link has been sent, please check your email to reset your password.';
          this.forgotPasswordForm.reset();
          this.turnstileWidget?.reset();
          this.turnstileService.clearToken();
          this.turnstileToken = null;
        },
        error: (err: any) => {
          this.showError = true;
          if (err.error && err.error.messages && err.error.messages.length > 0) {
            this.errorMessage = err.error.messages
              .map((msg: any) => msg.content)
              .filter((content: string | undefined) => content)
              .join(', ');
          } else if (err.error && typeof err.error === 'string') {
            this.errorMessage = err.error;
          } else {
            this.errorMessage = err.message || 'An error occurred while processing your request.';
          }

          if (err.status === 400 || err.status === 403) {
            this.turnstileWidget?.reset();
            this.turnstileService.clearToken();
            this.turnstileToken = null;
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }

  hasError(controlName: string, errorName: string) {
    const control = this.forgotPasswordForm.controls[controlName];
    return control.touched && control.hasError(errorName);
  }

  isInvalid(controlName: string) {
    const control = this.forgotPasswordForm.controls[controlName];
    return control.touched && control.errors;
  }
}
